import { AxiosResponse } from 'axios';

import { API } from '../../utils/axios';
import { APIResponseStatus } from '../types';
import { AccountUser, UpdateAccountResponse } from '../../features/account/types';

class AccountService {
  static getMe(uuid = '00000000-0000-0000-0000-000000000000') {
    return API.get<any, AxiosResponse<APIResponseStatus<AccountUser>>>(
      `v1/resources/Patient/${uuid}`,
    ).then((res) => res.data);
  }

  static updateAccountDetails(params: any) {
    return API.post<any, AxiosResponse<APIResponseStatus<UpdateAccountResponse>>>(
      `v1/resources/Patient`,
      params,
    ).then((res) => res.data);
  }
}

export interface FilePractitionerObject {
  resourceType: 'File';
  uuid: string;
  id: string;
  identifier: Array<{ system: string; value: string }>;
  parent?: { reference: string; identifier: { system: string; value: string } };
  type?: string;
  name?: string;
  description?: string;
  blob?: {
    reference: string;
    type: string;
    identifier: { system: string; value: string };
  };
  blobData?: {
    resourceType: string;
    uuid: string;
    id: string;
    identifier: Array<{ system: string; value: string }>;
    bucket: string;
    key: string;
    blob: { ETag: string; serverSideEncryption: string };
    contentType: string;
    contentLength: number;
    file: {
      reference: string;
      type: string;
      identifier: { system: string; value: string };
    };
  };
  url: string;
}

export interface FilePractitionerResponse extends APIResponseStatus {
  resource: {
    resourceType: string;
    type: string;
    entry: Array<{ resource: FilePractitionerObject }>;
  };
}

export default AccountService;
